var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alerts-container"},[_vm._t("default",null,{"clicked":_vm.openModal}),_c('CreateAccountModalForm',{attrs:{"filtersWord":_vm.filtersWord,"removeFilterItem":_vm.removeFilterItem,"filterFields":_vm.filterFields}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }